{
  "name": "@customd/kog",
  "version": "1.2.1",
  "description": "Kog CLI is a command-line tool engineered to streamline the initiation of your projects with Kreate templates and the integration of Kog components.",
  "publishConfig": {
    "access": "public"
  },
  "license": "MIT",
  "author": {
    "name": "Custom D",
    "url": "https://www.customd.com"
  },
  "keywords": [
    "components",
    "kog",
    "cli"
  ],
  "type": "module",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "files": [
    "dist"
  ],
  "bin": {
    "kog": "./dist/index.js"
  },
  "scripts": {
    "dev": "tsup --watch",
    "start": "node dist/index.js",
    "build": "tsup",
    "lint": "yarn lint:eslint && yarn lint:prettier && tsc --noemit",
    "lint:fix": "yarn lint:eslint:fix && yarn lint:prettier:fix && tsc --noemit",
    "lint:eslint": "eslint . --ext .js,.jsx,.cjs,.ts,.tsx",
    "lint:eslint:ci": "yarn lint:eslint --format gitlab --output-file gl-eslint-codequality.json",
    "lint:eslint:fix": "yarn lint:eslint --fix",
    "lint:prettier": "prettier \"**/*.+(js|jsx|ts|tsx|json)\" --check",
    "lint:prettier:ci": "prettier-formatter-gitlab 'prettier \"**/*.+(js|jsx|ts|tsx|json)\" --check'",
    "lint:prettier:fix": "yarn lint:prettier --write",
    "test": "jest",
    "test:ci": "jest --ci --coverage --coverageReporters=text --coverageReporters=cobertura --coverageReporters=html --reporters=jest-junit",
    "clean": "rimraf dist && rimraf tmp && rimraf package-lock.json && rimraf yarn.lock && rimraf yarn-error.log && rimraf node_modules"
  },
  "resolutions": {
    "strip-ansi": "6.0.1",
    "string-width": "4.2.3",
    "wrap-ansi": "7.0.0"
  },
  "dependencies": {
    "@antfu/ni": "^0.21.12",
    "@babel/core": "^7.24.0",
    "@babel/parser": "^7.24.0",
    "@babel/plugin-transform-typescript": "^7.23.6",
    "@ianvs/prettier-plugin-sort-imports": "^4.2.0",
    "chalk": "5.3.0",
    "commander": "^12.0.0",
    "diff": "^5.2.0",
    "dotenv": "^16.4.5",
    "execa": "^8.0.1",
    "fetch-git-repo-async": "^1.0.1",
    "fs-extra": "^11.2.0",
    "listr2": "^8.0.2",
    "node-fetch": "^3.3.2",
    "ora": "^8.0.1",
    "p-limit": "^5.0.0",
    "prompts": "^2.4.2",
    "tsconfig-paths": "^4.2.0",
    "tsup": "^8.0.2",
    "zod": "^3.22.4"
  },
  "devDependencies": {
    "@studiometa/prettier-formatter-gitlab": "^1.1.4",
    "@types/babel__core": "^7.20.5",
    "@types/fs-extra": "^11.0.4",
    "@types/jest": "^29.5.12",
    "@types/node": "^20.11.27",
    "@types/prompts": "^2.4.9",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "eslint": "^8.57.0",
    "eslint-config-airbnb": "^19.0.4",
    "eslint-config-airbnb-typescript": "^18.0.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-formatter-gitlab": "^5.1.0",
    "eslint-import-resolver-alias": "^1.1.2",
    "eslint-import-resolver-typescript": "^3.6.1",
    "eslint-plugin-hooks": "^0.4.3",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-jsx-a11y": "^6.8.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-react": "^7.34.0",
    "eslint-plugin-simple-import-sort": "^12.0.0",
    "jest": "^29.7.0",
    "jest-junit": "^16.0.0",
    "prettier": "3.2.5",
    "rimraf": "^5.0.5",
    "ts-jest": "^29.1.2",
    "type-fest": "^4.12.0",
    "typescript": "^5.4.2"
  }
}